import React from "react";

export default function TermsPage(){
  return (
    <div className="mx-auto max-w-3xl px-4 py-10 space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">Legal Notice</h1>
      <section className="space-y-4 text-sm leading-6 text-muted-foreground">
        <p className="text-foreground font-semibold">This platform is not for public use.</p>
        <p>sgt.law is an organizational platform developed for invitation-only use by participating organizations. Access is restricted to authorized users invited by their organization. If you do not have an invitation, do not attempt to create an account or use this service.</p>
        <p>By signing in, you acknowledge that you are acting on behalf of your organization and agree to follow its policies. Public registrations and public data processing are not supported.</p>
      </section>
    </div>
  );
}